<template>
    <div>
        <OrderDesc v-if="order" :orderItem="order"></OrderDesc>
        <OrderMaterial ref="rows"> </OrderMaterial>
    </div>
</template>

<script>
import { getByOrderNo } from './api'

export default {
    props: [],
    data() {
        return {
            loading: false,
            optMap: {},
            order: null,
            datas: [],
        }
    },
    created() {
        let orderNo = this.$route.params.id
        this.getData(orderNo)
    },
    methods: {
        getData(orderNo) {
            // 初始化函数
            const body = {
                orderNo
            }
            this.loading = true
            getByOrderNo(body).then((res) => {
                this.loading = false;
                this.order = res;
                this.datas = res.orderItemEntities;
                this.$refs.rows.data = this.datas;
                console.log('this.$refs.rows', this.$refs.rows);

            }).catch((error) => {
                this.loading = false;
                console.error(error);
            });
        },
    },
    computed: {
        open: {
            get() {
                return this.show
            },
            set(val) {
                this.$emit('update:show', val)
            },
        },
    },
    watch: {
        show(val) {
            if (val) {
                this.formValue = { orderStatus: '1' }
                this.orderStatus = '1'
            }
        },
    },
}
</script>

<style lang="scss">
html,
body {
    height: auto;
}
</style>
